import React from 'react'
import classNames from 'classnames'

import style from './TmoCheckbox.module.css'

function TmoCheckbox({
  isChecked = false,
  onChange,
  onClick,
  id,
  value,
  disabled,
  className,
  checkbox,
  tabIndex,
  hideLabel = false,
  testId,
  ...rest
}) {
  const handleChange = (target) => {
    onChange(target)
  }
  const attributes = {}
  if (onClick) {
    attributes['onClick'] = (e) => {
      e.stopPropagation()
    }
  }
  return (
    <div
      className={classNames(
        checkbox === 'magentaCheckbox'
          ? style.magenta_checkbox
          : style.container
      )}
    >
      <label />
      <input
        className={classNames('TmoCheckbox', className)}
        id={id}
        type='checkbox'
        checked={isChecked}
        onChange={handleChange}
        value={value}
        disabled={disabled}
        aria-label={value}
        aria-checked={isChecked}
        {...attributes}
        data-testid={testId}
        {...rest}
      />
      {!hideLabel && <label htmlFor={id}> {value}</label>}
    </div>
  )
}

export default TmoCheckbox
